import { StatusRules } from '@razzfazz.io/seqitracker-util';

let statusRules;
const init = function(envName, mocoTaskIDs, dayTypes) {
  statusRules = new StatusRules(envName, mocoTaskIDs, dayTypes);
}

const applyDayRules = function() {
  return statusRules.applyDayRules(...arguments);
}
const applyMonthRules = function() {
  return statusRules.applyMonthRules(...arguments);
}

export {
  init,
  applyDayRules,
  applyMonthRules
}